import { render, staticRenderFns } from "./StagingRelatedDocsSectionValueEditor.vue?vue&type=template&id=0da7b970"
import script from "./StagingRelatedDocsSectionValueEditor.vue?vue&type=script&lang=ts"
export * from "./StagingRelatedDocsSectionValueEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports